import { IconSvgProps } from "../types";

export const Partners = ({ size }: IconSvgProps) => (
    <svg
        id="icon-content-process"
        width={size}
        height={size}
        viewBox="0 0 28 31"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d="M7 22C7 18.134 10.134 15 14 15C17.866 15 21 18.134 21 22V31H7V22Z"
            fill="#FFA900"
        />
        <path
            d="M20 6C20 9.31371 17.3137 12 14 12C10.6863 12 8 9.31371 8 6C8 2.68629 10.6863 0 14 0C17.3137 0 20 2.68629 20 6Z"
            fill="#FFA900"
        />
        <path
            d="M20.8118 11.8824C21.1959 11.9595 21.5932 12 22 12C25.3137 12 28 9.31371 28 6C28 2.68629 25.3137 0 22 0C21.5932 0 21.1959 0.0404842 20.8118 0.117642C22.1753 1.69516 23 3.75127 23 6C23 8.24873 22.1753 10.3048 20.8118 11.8824Z"
            fill="#FFA900"
        />
        <path
            d="M7.18821 0.117642C5.82473 1.69516 5 3.75127 5 6C5 8.24873 5.82473 10.3048 7.18821 11.8824C6.80413 11.9595 6.40679 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C6.4068 0 6.80413 0.0404842 7.18821 0.117642Z"
            fill="#FFA900"
        />
        <path
            d="M6.85857 15C5.09032 16.8037 4 19.2745 4 22V31H0V20C0 17.2386 2.23858 15 5 15H6.85857Z"
            fill="#FFA900"
        />
        <path
            d="M24 31V22C24 19.2745 22.9097 16.8037 21.1414 15H23C25.7614 15 28 17.2386 28 20V31H24Z"
            fill="#FFA900"
        />
    </svg>
);
